import './InfoBox.css';
import React from 'react';
import { Translate } from 'react-localize-redux';

export default props => {
  const phoneLink = `tel:${props.phone}`;
  return (
    <div className="bg">
      <h3>
        <Translate id={props.heading} />
      </h3>
      <p>
        {' '}
        <Translate id={props.text} />
      </p>
      <h3 className="brand">
        <a href={phoneLink}>{props.phone}</a>
      </h3>
      {props.phone && (
        <p>
          {props.serviceHoursLine1}
          <br />
          {props.serviceHoursLine2}
        </p>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/InfoBox.js